<template>
  <div>
    <!-- Start: Content -->
    <section class="reservation-info" v-if="!isLoading">
      <div class="container">
        <div class="row">
          <!-- Start: Form Contact -->
          <div class="col-sm-6 col-sm-offset-1">
            <template v-if="isLoadingForm">
              <div class="filter-box--left">
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                </div>
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                </div>
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                </div>
                <div class="car-specification mb-20">
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                  <div class="loader-list--lines shine --label-input"></div>
                  <div class="loader-list--lines shine --input"></div>
                </div>
              </div>
            </template>
            <template v-else>
              <div id="form-contact">
                <div class="summary-error" v-if="$v.reservationRequest.$error">
                  This form has errors
                </div>
                <form @submit.prevent="validateDoubleBook">
                  <!-- Start: Booker -->
                  <div>
                    <header>
                      Booker information
                      <span class="--blue"
                        >Please fill all information below.</span
                      >
                    </header>
                    <div class="row">
                      <div class="col-sm-12">
                        <div v-if="useCompanySelection" class="form-group">
                          <label class="required">Company</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.reservationRequest.booker.companyId.$error,
                            }"
                            placeholder=""
                            label="name"
                            v-model="reservationRequest.booker.companyId"
                            :options="companies"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.id"
                            @input="getBookersByCompanyId"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.booker.companyId.required
                            "
                          >
                            Company is required
                          </small>
                        </div>
                        <div v-if="useCustomerSelection" class="form-group">
                          <label class="required">Customer</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.reservationRequest.booker.customerId.$error,
                            }"
                            placeholder=""
                            label="label"
                            v-model="reservationRequest.booker.customerId"
                            :options="customersAsBooker"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.id"
                            @input="onChangeBooker"
                            :disabled="!reservationRequest.booker.companyId"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.booker.customerId.required
                            "
                          >
                            Customer is required
                          </small>
                        </div>
                        <template
                          v-if="
                            reservationRequest.booker.customerId &&
                            isUseFreetext(reservationRequest.booker.customerId)
                          "
                        >
                          <div class="form-group">
                            <label class="required">Select Title</label>
                            <div
                              class="btn-group btn-group-toggle"
                              data-toggle="buttons"
                            >
                              <label
                                class="btn"
                                :class="{
                                  active:
                                    reservationRequest.booker.freetext.title ===
                                    item.value,
                                }"
                                v-for="(item, index) in personTitles"
                                :key="index"
                                @click="
                                  reservationRequest.booker.freetext.title =
                                    item.value
                                "
                              >
                                <input
                                  type="radio"
                                  name="booker_title"
                                  autocomplete="off"
                                  :value="item.value"
                                  :checked="
                                    reservationRequest.booker.freetext.title ===
                                    item.value
                                  "
                                  v-model="
                                    reservationRequest.booker.freetext.title
                                  "
                                />
                                {{ item.text }}
                              </label>
                            </div>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.booker.freetext.title
                                  .required
                              "
                              style="display: block"
                            >
                              Title is required
                            </small>
                          </div>
                          <div
                            class="form-group"
                            v-if="
                              reservationRequest.booker.freetext.title ===
                              'Other'
                            "
                          >
                            <label class="">Title</label>
                            <input
                              type="text"
                              class="form-control alphabets-only"
                              v-model="
                                reservationRequest.booker.freetext.otherTitle
                              "
                            />
                          </div>
                          <div class="form-group">
                            <label class="required">Full Name</label>
                            <input
                              type="text"
                              class="form-control alphabets-characters-only"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  !$v.reservationRequest.booker.freetext
                                    .fullName.required,
                              }"
                              v-model="
                                reservationRequest.booker.freetext.fullName
                              "
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.booker.freetext.fullName
                                  .required
                              "
                              style="display: block"
                            >
                              Fullname is required
                            </small>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.booker.freetext.fullName
                                  .maxLength
                              "
                              style="display: block"
                            >
                              Fullname must be less than
                              {{
                                $v.reservationRequest.booker.freetext.fullName
                                  .$params.maxLength.max
                              }}
                              characters
                            </small>
                          </div>
                          <div class="row">
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label class="required">Phone</label>
                                <v-select
                                  class="v-search-select"
                                  placeholder=""
                                  label="label"
                                  v-model="
                                    reservationRequest.booker.freetext.phoneCode
                                  "
                                  :options="phoneCodes"
                                  :clearable="false"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.dial"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      !$v.reservationRequest.booker.freetext
                                        .phoneCode.required,
                                  }"
                                >
                                  <template #search="{ attributes, events }">
                                    <input
                                      class="vs__search"
                                      name="booker_phoneCode"
                                      v-bind="attributes"
                                      v-on="events"
                                    />
                                  </template>
                                  <template slot="option" slot-scope="option">
                                    <div class="phone-wrapper">
                                      <div
                                        class="phone-icon"
                                        :class="option.icon"
                                      ></div>
                                      <div class="phone-text">
                                        {{ option.iata }}
                                      </div>
                                    </div>
                                  </template>
                                </v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.reservationRequest.booker.freetext
                                      .phoneCode.required
                                  "
                                  style="display: block"
                                >
                                  Phone code is required
                                </small>
                              </div>
                            </div>
                            <div
                              class="col-sm-8"
                              style="padding-left: 0; padding-top: 30px"
                            >
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control numbers-only"
                                  name="booker_phoneNumber"
                                  v-model="sanitizePhoneNumberBooker"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      !$v.reservationRequest.booker.freetext
                                        .phoneNumber.required,
                                  }"
                                />
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.reservationRequest.booker.freetext
                                      .phoneNumber.required
                                  "
                                  style="display: block"
                                >
                                  Phone number is required
                                </small>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.reservationRequest.booker.freetext
                                      .phoneNumber.maxLength
                                  "
                                  style="display: block"
                                >
                                  Phone Number must be less than
                                  {{
                                    $v.reservationRequest.booker.freetext
                                      .phoneNumber.$params.maxLength.max
                                  }}
                                  characters
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="required">Email</label>
                            <input
                              class="form-control"
                              placeholder="e.g youremail@gmail.com"
                              v-model="reservationRequest.booker.freetext.email"
                              maxlength="100"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  !$v.reservationRequest.booker.freetext.email
                                    .required,
                              }"
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.booker.freetext.email
                                  .required
                              "
                              style="display: block"
                            >
                              Email is required
                            </small>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                $v.reservationRequest.booker.freetext.email
                                  .required &&
                                !$v.reservationRequest.booker.freetext.email
                                  .email
                              "
                              style="display: block"
                            >
                              Email is invalid
                            </small>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <!-- End: Booker -->

                  <!-- Start: Passenger -->
                  <div class="passenger-information">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="isPassengerSameAsBooker"
                        @change="copyBooker()"
                      />
                      <span
                        class="pl-5 font-weight-normal v-align-middle text-filter"
                      >
                        Same as Booking Contact Information
                      </span>
                    </label>
                    <header>
                      Passenger information
                      <span>Please fill all information below.</span>
                    </header>
                    <div class="row">
                      <div class="col-sm-12">
                        <div v-if="useCompanySelection" class="form-group">
                          <label class="required">Company</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.reservationRequest.passengers.$each[0]
                                  .companyId.$error,
                            }"
                            placeholder=""
                            label="name"
                            v-model="reservationRequest.passengers[0].companyId"
                            :options="companies"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.id"
                            :disabled="isPassengerSameAsBooker"
                            @input="getPassengersByCompanyId"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.passengers.$each[0]
                                .companyId.required
                            "
                          >
                            Company is required
                          </small>
                        </div>
                        <div v-if="useCustomerSelection" class="form-group">
                          <label class="required">Customer</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.reservationRequest.passengers.$each[0]
                                  .customerId.$error,
                            }"
                            placeholder=""
                            label="label"
                            v-model="
                              reservationRequest.passengers[0].customerId
                            "
                            :options="customersAsPassenger"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.id"
                            :disabled="
                              isPassengerSameAsBooker ||
                              !reservationRequest.passengers[0].companyId
                            "
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.passengers.$each[0]
                                .customerId.required
                            "
                          >
                            Customer is required
                          </small>
                        </div>
                        <template
                          v-if="
                            reservationRequest.passengers[0].customerId &&
                            isUseFreetext(
                              reservationRequest.passengers[0].customerId
                            )
                          "
                        >
                          <div class="form-group">
                            <label class="required">Select Title</label>
                            <div
                              class="btn-group btn-group-toggle"
                              data-toggle="buttons"
                            >
                              <label
                                class="btn"
                                :class="{
                                  active:
                                    reservationRequest.passengers[0].title ===
                                    item.value,
                                }"
                                v-for="(item, index) in personTitles"
                                :key="index"
                                @click="
                                  reservationRequest.passengers[0].title =
                                    item.value
                                "
                                :disabled="isPassengerSameAsBooker"
                              >
                                <input
                                  type="radio"
                                  name="booker_title"
                                  autocomplete="off"
                                  :value="item.value"
                                  :checked="
                                    reservationRequest.passengers[0].title ===
                                    item.value
                                  "
                                  v-model="
                                    reservationRequest.passengers[0].title
                                  "
                                  :disabled="isPassengerSameAsBooker"
                                />
                                {{ item.text }}
                              </label>
                            </div>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.passengers.$each[0].title
                                  .required
                              "
                              style="display: block"
                            >
                              Title is required
                            </small>
                          </div>
                          <div
                            class="form-group"
                            v-if="
                              reservationRequest.passengers[0].title === 'Other'
                            "
                          >
                            <label class="">Title</label>
                            <input
                              type="text"
                              class="form-control alphabets-only"
                              v-model="
                                reservationRequest.passengers[0].otherTitle
                              "
                              :disabled="isPassengerSameAsBooker"
                            />
                          </div>
                          <div class="form-group">
                            <label class="required">Full Name</label>
                            <input
                              type="text"
                              class="form-control alphabets-characters-only"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  !$v.reservationRequest.passengers.$each[0]
                                    .fullName.required,
                              }"
                              v-model="
                                reservationRequest.passengers[0].fullName
                              "
                              :disabled="isPassengerSameAsBooker"
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.passengers.$each[0]
                                  .fullName.required
                              "
                              style="display: block"
                            >
                              Fullname is required
                            </small>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.passengers.$each[0]
                                  .fullName.maxLength
                              "
                              style="display: block"
                            >
                              Fullname must be less than
                              {{
                                $v.reservationRequest.passengers.$each[0]
                                  .fullName.$params.maxLength.max
                              }}
                              characters
                            </small>
                          </div>
                          <div class="row">
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label class="required">Phone</label>
                                <v-select
                                  class="v-search-select"
                                  placeholder=""
                                  label="label"
                                  v-model="
                                    reservationRequest.passengers[0].phoneCode
                                  "
                                  :options="phoneCodes"
                                  :clearable="false"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.dial"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      !$v.reservationRequest.passengers.$each[0]
                                        .phoneCode.required,
                                  }"
                                  :disabled="isPassengerSameAsBooker"
                                >
                                  <template #search="{ attributes, events }">
                                    <input
                                      class="vs__search"
                                      name="booker_phoneCode"
                                      v-bind="attributes"
                                      v-on="events"
                                    />
                                  </template>
                                  <template slot="option" slot-scope="option">
                                    <div class="phone-wrapper">
                                      <div
                                        class="phone-icon"
                                        :class="option.icon"
                                      ></div>
                                      <div class="phone-text">
                                        {{ option.iata }}
                                      </div>
                                    </div>
                                  </template>
                                </v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.reservationRequest.passengers.$each[0]
                                      .phoneCode.required
                                  "
                                  style="display: block"
                                >
                                  Phone code is required
                                </small>
                              </div>
                            </div>
                            <div
                              class="col-sm-8"
                              style="padding-left: 0; padding-top: 30px"
                            >
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control numbers-only"
                                  name="booker_phoneNumber"
                                  v-model="sanitizePhoneNumberPax"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      !$v.reservationRequest.passengers.$each[0]
                                        .phoneNumber.required,
                                  }"
                                  :disabled="isPassengerSameAsBooker"
                                />
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.reservationRequest.passengers.$each[0]
                                      .phoneNumber.required
                                  "
                                  style="display: block"
                                >
                                  Phone number is required
                                </small>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.reservationRequest.passengers.$each[0]
                                      .phoneNumber.maxLength
                                  "
                                  style="display: block"
                                >
                                  Phone Number must be less than
                                  {{
                                    $v.reservationRequest.passengers.$each[0]
                                      .phoneNumber.$params.maxLength.max
                                  }}
                                  characters
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="required">Email</label>
                            <input
                              class="form-control"
                              placeholder="e.g youremail@gmail.com"
                              v-model="reservationRequest.passengers[0].email"
                              maxlength="100"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  !$v.reservationRequest.passengers.$each[0]
                                    .email.required,
                              }"
                              :disabled="isPassengerSameAsBooker"
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.passengers.$each[0].email
                                  .required
                              "
                              style="display: block"
                            >
                              Email is required
                            </small>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                $v.reservationRequest.passengers.$each[0].email
                                  .required &&
                                !$v.reservationRequest.passengers.$each[0].email
                                  .email
                              "
                              style="display: block"
                            >
                              Email is invalid
                            </small>
                          </div>
                        </template>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Number of Passengers</label>
                              <input
                                type="number"
                                min="1"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    (!$v.reservationRequest.numberOfPax
                                      .maxValue ||
                                      !$v.reservationRequest.numberOfPax
                                        .minValue),
                                }"
                                v-model="reservationRequest.numberOfPax"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.numberOfPax.maxValue
                                "
                                style="display: block"
                              >
                                {{
                                  `Maximum number of passengers ${vehicle.feature.paxCapacity}`
                                }}
                              </small>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.numberOfPax.minValue
                                "
                                style="display: block"
                              >
                                {{ `Minimum number of passenger 1` }}
                              </small>
                            </div>
                            <div class="form-group">
                              <label>Number of Big Luggages</label>
                              <input
                                type="number"
                                min="1"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.reservationRequest.numberOfBigLuggages
                                      .minValue,
                                }"
                                v-model="reservationRequest.numberOfBigLuggages"
                              />
                              <!-- <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.numberOfBigLuggages
                                .maxValue
                            "
                            style="display: block"
                          >
                            {{
                              `Maximum number of big luggages ${vehicle.feature.largeBaggageCapacity}`
                            }}
                          </small> -->
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.numberOfBigLuggages
                                    .minValue
                                "
                                style="display: block"
                              >
                                {{ `Minimum number of big luggages 1` }}
                              </small>
                            </div>
                            <div class="form-group">
                              <label>Number of Small Luggages</label>
                              <input
                                type="number"
                                min="0"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.reservationRequest.numberOfSmallLuggages
                                      .minValue,
                                }"
                                v-model="
                                  reservationRequest.numberOfSmallLuggages
                                "
                              />
                              <!-- <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.numberOfSmallLuggages
                                .maxValue
                            "
                            style="display: block"
                          >
                            {{
                              `Maximum number of big luggages ${vehicle.feature.smallBaggageCapacity}`
                            }}
                          </small> -->
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.numberOfSmallLuggages
                                    .minValue
                                "
                                style="display: block"
                              >
                                {{ `Minimum number of small luggages 1` }}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End: Passenger -->

                  <!-- Start: Ancillary -->
                  <div
                    class="box-addons"
                    v-if="hasAncillary"
                    style="padding-top: 20px"
                  >
                    <div class="panel-group" id="accordion">
                      <div class="panel panel-default">
                        <div class="panel-heading">
                          <h4 class="panel-title">
                            <a
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapse1"
                            >
                              + Extras
                            </a>
                          </h4>
                        </div>
                        <div id="collapse1" class="panel-collapse collapse">
                          <div class="panel-body">
                            <div class="table-p10">
                              <div class="table-responsive">
                                <table class="table table-hover mtz">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th>Item Name</th>
                                      <th>Price</th>
                                      <th
                                        class="text-center"
                                        style="width: 125px"
                                      >
                                        Qty
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(item, index) in ancillaries"
                                      :key="item.masterClassAncillaryId"
                                    >
                                      <td class="text-center">
                                        {{ index + 1 }}
                                      </td>
                                      <td>{{ item.name }}</td>
                                      <td>
                                        {{ item.currencyCode }}
                                        {{
                                          $currencyFormat(
                                            item.currencyCode,
                                            item.rate
                                          )
                                        }}
                                      </td>
                                      <td class="text-center">
                                        <input
                                          class="form-control numbers-only"
                                          type="number"
                                          v-model="item.quantity"
                                          @change="onChangeAncillary(item)"
                                          @keyup="onChangeAncillary(item)"
                                          @blur="onBlurAncillary(item)"
                                          min="0"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End: Ancillary -->

                  <!-- Start: Airport Transfer Pick-up Details -->
                  <div class="passenger-information" v-if="isAirportTransfer">
                    <header>
                      {{
                        isAirportZone || isAirportZoneDropOff
                          ? "Flight Details"
                          : "Pick-up Details"
                      }}
                      <span>Please fill all information below.</span>
                    </header>
                    <div class="row">
                      <div class="col-sm-12">
                        <!-- Start: Required Flight Information -->
                        <div class="row" v-if="isAirportZone">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Airline</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.reservationRequest.departureAirline
                                      .$error,
                                }"
                                placeholder="Select an airline"
                                label="label"
                                v-model="reservationRequest.departureAirline"
                                :options="orderedAirlines"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.iataCode"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  $v.reservationRequest.departureAirline
                                    .$error &&
                                  !$v.reservationRequest.departureAirline
                                    .required
                                "
                                >Airline is required</small
                              >
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">Flight/Tail No.</label>
                              <input
                                class="form-control alphabets-numbers-only"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.reservationRequest.departureFlightNumber
                                      .$error,
                                }"
                                type="text"
                                name="departure_flightNumber"
                                autocomplete="off"
                                v-model="
                                  reservationRequest.departureFlightNumber
                                "
                              />
                              <div
                                v-if="
                                  isSubmitted &&
                                  $v.reservationRequest.departureFlightNumber
                                    .$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    !$v.reservationRequest.departureFlightNumber
                                      .required
                                  "
                                  >Flight Number is invalid</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    !$v.reservationRequest.departureFlightNumber
                                      .maxLength
                                  "
                                  >Flight Number must be less than
                                  {{
                                    $v.reservationRequest.departureFlightNumber
                                      .$params.maxLength.max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- End: Flight Information -->
                        <!-- Start: Not Required Flight Information -->
                        <div
                          class="row"
                          v-if="!isAirportZone && isAirportZoneDropOff"
                        >
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Airline</label>
                              <v-select
                                class="v-search-select"
                                placeholder="Select an airline"
                                label="label"
                                v-model="reservationRequest.departureAirline"
                                :options="orderedAirlines"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.iataCode"
                              ></v-select>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Flight/Tail No.</label>
                              <input
                                class="form-control alphabets-numbers-only"
                                type="text"
                                name="departure_flightNumber"
                                autocomplete="off"
                                v-model="
                                  reservationRequest.departureFlightNumber
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <!-- End: Flight Information -->
                        <!-- Start: Notes to Driver -->
                        <div class="form-group">
                          <label for>Notes to Driver</label>
                          <textarea
                            class="form-control"
                            rows="5"
                            name="notes"
                            v-model="reservationRequest.notes"
                          ></textarea>
                          <div class="text-right word-count">
                            {{ driverNotesLength }} &#47; 500 characters
                          </div>
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.notes.maxLength
                            "
                            >Notes must be less than
                            {{
                              $v.reservationRequest.notes.$params.maxLength.max
                            }}
                            characters</small
                          >
                        </div>
                        <!-- End: Notes to Driver -->
                        <div class="form-group">
                          <label for>Upload Name Sign</label>
                          <input
                            type="file"
                            id="upload-signage"
                            class="form-control"
                            accept=".png, .jpeg, .jpg, .pdf"
                            @change="uploadSignage($event)"
                          />

                          <div class="d-flex justify-between">
                            <div class="upload-signage-box">
                              <label
                                for="upload-signage"
                                class="upload-signage-label"
                                ><span
                                  class="file-accept-text"
                                  v-if="!signageImageName"
                                  >JPG, JPEG, PNG, PDF</span
                                ><span class="file-accept-text" v-else>{{
                                  signageImageName
                                }}</span>
                                <div type="button" class="btn btn-browse">
                                  Browse
                                </div>
                              </label>
                              <small class="form-text"
                                >• Passenger full name is the default
                                sign</small
                              >
                              <br />
                              <small class="form-text"
                                >• Maximum file size 1MB</small
                              >
                              <br />
                              <small class="form-text"
                                >• Aspect ratio: 16:9, Landscape</small
                              >
                            </div>
                            <div
                              class="preview-signage-image"
                              v-if="reservationRequest.signage.url"
                            >
                              <img
                                :src="reservationRequest.signage.url"
                                alt="signage-preview-image"
                                class="signage-image"
                                v-if="!isPDFFile"
                              />
                              <PdfViewer
                                :pdf-url="reservationRequest.signage.url"
                                v-else
                              />
                              <button
                                type="button"
                                class="btn-delete-preview-img"
                                @click="clearPreviewSignage()"
                              >
                                X
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End: Airport Transfer Pick-up Details -->

                  <!-- Start: Additional form -->
                  <div class="passenger-information">
                    <header>Customer Information</header>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>PNR/Client Booking No.</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.reservationRequest.passengerNameRecord
                                      .$error,
                                }"
                                v-model="reservationRequest.passengerNameRecord"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Project Name</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="reservationRequest.project"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Passenger Employee ID</label>
                              <input
                                type="text"
                                v-model="
                                  reservationRequest.passengers[0].employeeId
                                "
                                class="form-control"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Passenger Cost Centre</label>
                              <input
                                type="text"
                                v-model="
                                  reservationRequest.passengers[0].costCenter
                                "
                                class="form-control"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Booker Employee ID</label>
                              <input
                                type="text"
                                v-model="reservationRequest.booker.employeeId"
                                class="form-control"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Booker Cost Centre</label>
                              <input
                                type="text"
                                v-model="reservationRequest.booker.costCenter"
                                class="form-control"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Ride Type</label>
                              <v-select
                                class="v-search-select"
                                label="text"
                                v-model="reservationRequest.rideType"
                                :options="rideTypeTypes"
                                placeholder="Select ride type"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              ></v-select>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Additional Request</label>
                              <div class="form-group">
                                <textarea
                                  class="form-control"
                                  rows="2"
                                  name="additionalRequest"
                                  v-model="reservationRequest.additionalRequest"
                                ></textarea>
                                <div class="text-right word-count">
                                  {{ additionalRequestLength }}
                                  &#47; 500 characters
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End: Additional form -->

                  <!-- Start: Additional form -->
                  <div class="passenger-information" v-if="isAllowAdminNotes">
                    <header>Admin – For internal use only</header>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="row">
                          <div
                            class="col-sm-12"
                            v-if="userProfile.userType === 'TenantUser'"
                          >
                            <div class="form-group">
                              <label>Provider</label>
                              <v-select
                                class="v-search-select"
                                placeholder="Select provider"
                                label="name"
                                v-model="reservationRequest.selectedProvider"
                                :options="providers"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                              ></v-select>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label for>Admin Notes</label>
                              <textarea
                                class="form-control"
                                rows="5"
                                name="adminNotes"
                                v-model="reservationRequest.adminNotes"
                              ></textarea>
                              <div class="text-right word-count">
                                {{ adminNotesLength }} &#47; 500 characters
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Invoice Number</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="reservationRequest.invoiceNumber"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End: Additional form -->

                  <button type="submit" class="btn btn-primary mt-20">
                    <!-- Proceed to Payment -->
                    Review and Pay
                  </button>
                </form>
              </div>
            </template>
          </div>
          <!-- End: Form Contact -->

          <!-- Start: Right Panel -->
          <div class="col-sm-5 postick">
            <div class="price-detail-header">
              <div class="grand-total">
                <table class="table table-amount mt-5">
                  <thead>
                    <tr>
                      <th class="text-left --green v-align-top">
                        <div class="flex-column">
                          <span
                            >{{
                              checkSameCurrencyCode(vehicle.currencyCode)
                                ? "Amount to pay"
                                : "Estimated Amount"
                            }}
                          </span>
                          <span
                            class="estimated-subtitle"
                            v-if="!checkSameCurrencyCode(vehicle.currencyCode)"
                          >
                            Subject to exchange rates at time of payment
                          </span>
                        </div>
                      </th>
                      <th class="text-right v-align-top">
                        <div class="flex-column">
                          <span>
                            {{ vehicle.currencyCode }}
                            {{
                              $currencyFormat(vehicle.currencyCode, grandTotal)
                            }}
                          </span>
                          <span
                            class="text-10"
                            v-if="
                              hasConversionRate &&
                              !checkSameCurrencyCode(vehicle.currencyCode)
                            "
                            >{{ conversionRate.currency }}
                            {{
                              $currencyFormat(
                                conversionRate.currency,
                                getLocalCurrency(grandTotal)
                              )
                            }}</span
                          >
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left v-align-top">Base Fare</td>
                      <td class="text-right flex-column v-align-top">
                        <span>
                          {{ vehicle.currencyCode }}
                          {{
                            $currencyFormat(
                              vehicle.currencyCode,
                              vehicle.baseFare
                            )
                          }}
                        </span>
                        <span
                          class="text-10 --grey45 text-right"
                          v-if="
                            hasConversionRate &&
                            !checkSameCurrencyCode(vehicle.currencyCode)
                          "
                        >
                          {{ conversionRate.currency }}
                          {{
                            $currencyFormat(
                              conversionRate.currency,
                              getLocalCurrency(vehicle.baseFare)
                            )
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr v-if="isSelfDrive">
                      <td class="text-left">Insurance</td>
                      <td class="text-right">
                        {{ vehicle.currencyCode }}
                        {{
                          $currencyFormat(
                            vehicle.currencyCode,
                            getLocalCurrency(totalInsurance)
                          )
                        }}
                      </td>
                    </tr>
                    <tr v-if="isSelfDrive">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="insurance in vehicle.selfDriveRate.items"
                            :key="insurance.code"
                          >
                            {{ insurance.name }} ({{ insurance.code }})
                            <span class="value">
                              {{ vehicle.currencyCode }}
                              {{
                                $currencyFormat(
                                  vehicle.currencyCode,
                                  insurance.rate
                                )
                              }}
                            </span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="hasSurcharge">
                      <td class="text-left v-align-top">Surcharge</td>
                      <td class="text-right flex-column">
                        <span>
                          {{ vehicle.currencyCode }}
                          {{
                            $currencyFormat(
                              vehicle.currencyCode,
                              vehicle.surcharge
                            )
                          }}
                        </span>
                        <span
                          class="text-10 --grey45 text-right"
                          v-if="
                            hasConversionRate &&
                            !checkSameCurrencyCode(vehicle.currencyCode)
                          "
                          >{{ conversionRate.currency }}
                          {{
                            $currencyFormat(
                              conversionRate.currency,
                              getLocalCurrency(vehicle.surcharge)
                            )
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr v-if="hasSurcharge">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="(
                              surcharge, key, index
                            ) in vehicle.surcharges"
                            :key="index"
                            class="v-align-top"
                            style="line-height: 30px"
                          >
                            {{ key
                            }}<span
                              class="value flex-column"
                              style="line-height: 20px"
                            >
                              <div class="text-right">
                                {{ vehicle.currencyCode }}
                                {{
                                  $currencyFormat(
                                    vehicle.currencyCode,
                                    surcharge
                                  )
                                }}
                              </div>
                              <span
                                class="text-10 text-right --grey45"
                                v-if="
                                  hasConversionRate &&
                                  !checkSameCurrencyCode(vehicle.currencyCode)
                                "
                              >
                                {{ conversionRate.currency }}
                                {{
                                  $currencyFormat(
                                    conversionRate.currency,
                                    getLocalCurrency(surcharge)
                                  )
                                }}
                              </span>
                            </span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="isAncillarySelected">
                      <td class="text-left v-align-top">Ancillary</td>
                      <td class="text-right flex-column">
                        <span>
                          {{ vehicle.currencyCode }}
                          {{
                            $currencyFormat(
                              vehicle.currencyCode,
                              totalAncillary
                            )
                          }}
                        </span>
                        <span
                          class="text-10"
                          v-if="
                            hasConversionRate &&
                            !checkSameCurrencyCode(vehicle.currencyCode)
                          "
                          >{{ conversionRate.currency }}
                          {{
                            $currencyFormat(
                              conversionRate.currency,
                              getLocalCurrency(totalAncillary)
                            )
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr v-if="isAncillarySelected" id="ancillary-list-item">
                      <td colspan="2">
                        <ul class="table-list ancillary-list">
                          <li
                            v-for="(ancillary, index) in selectedAncillaries"
                            :key="index"
                            class="ancillary-item"
                          >
                            <div class="ancillary-info">
                              <span class="ancillary-name">
                                {{ ancillary.name }}
                              </span>

                              <span class="ancillary-quantity">
                                x{{ ancillary.quantity }}
                              </span>
                            </div>

                            <span class="value ancillary-price">
                              <span class="--grey25">
                                {{ vehicle.currencyCode }}
                                {{
                                  $currencyFormat(
                                    vehicle.currencyCode,
                                    ancillary.subtotal
                                  )
                                }}
                              </span>

                              <span
                                class="text-10 text-right --grey45"
                                v-if="
                                  hasConversionRate &&
                                  !checkSameCurrencyCode(vehicle.currencyCode)
                                "
                              >
                                {{ conversionRate.equivalentCurrencyCode }}
                                {{
                                  $currencyFormat(
                                    conversionRate.currency,
                                    getLocalCurrency(ancillary.subtotal)
                                  )
                                }}
                              </span>
                            </span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="reservation-summary--small">
              <div class="dropandpickup cRow flex-wrap">
                <div class="col-sm-6 plz">
                  <div class="location-pick-up">
                    {{ searchParameterPickUpLocation }}
                    <span class="address-description">{{
                      searchParameterPickUpLocationAddress
                    }}</span>
                  </div>
                  <div class="row mt-10">
                    <div class="col-sm-12 prz">
                      <div class="rent-date">
                        <i class="ic-date-picker"></i> {{ shortPickUpDate }}
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ shortPickUpTime }}
                        <span class="utc-zone">{{
                          searchParameter.pickUpDate.offsetName
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 prz divider-left">
                  <div class="location-drop-off text-right">
                    {{ searchParameterDropOffLocation }}
                    <span class="address-description">{{
                      searchParameterDropOffLocationAddress
                    }}</span>
                  </div>
                  <div class="row mt-10">
                    <div class="col-sm-12 text-right">
                      <div class="rent-date">
                        {{ shortDropOffDate }}
                        <i class="ic-date-picker" style="margin-left: 4px"></i>
                      </div>
                    </div>
                    <div class="col-sm-12 text-right">
                      <div class="rent-time">
                        {{ shortDropOffTime }}
                        <span class="utc-zone">{{
                          searchParameter.pickUpDate.offsetName
                        }}</span>
                        <i class="ic-time" style="margin-left: 4px"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="cRow mt-20 w-full flex-wrap"
                  v-if="rateTagging.length"
                >
                  <div class="col-sm-12 text-center w-full">
                    <div class="row-badge">
                      <span
                        class="badge badge-tag"
                        v-for="tag in rateTagging"
                        :key="tag.id"
                        :style="`color: ${tag.textColor}; background: ${tag.backgroundColor}`"
                        >{{ tag.text }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="overlimit-info"
                v-if="searchParameter.serviceType === 'Rental'"
              >
                <div class="text-info">
                  <span class="info-icon mhide"></span>Returns more than one
                  hour will be charged an overtime fee.
                </div>
              </div>

              <div class="cRow">
                <template v-if="searchParameter.mode === 'OnDemand'">
                  <div class="col-sm-7">
                    <img :src="vehicle.imageUri" class="cars-image" alt />
                  </div>
                  <div class="col-sm-5">
                    <div class="provider-img">
                      <img :src="vehicle.providers[0].imageUri" alt />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-sm-12">
                    <img :src="vehicle.imageUri" class="cars-image" alt />
                  </div>
                </template>
              </div>

              <div class="row text-center">
                <div class="table-legend mt-15">
                  <ul>
                    <li v-if="isAirportTransfer">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-else><i class="ic-time"></i>Hourly Booking</li>
                  </ul>
                </div>

                <div>
                  <div v-if="hasVehicleName">
                    <span class="cars-brand">
                      {{ vehicle.factoryName }} {{ vehicle.brandName }}
                    </span>
                    or equivalent
                  </div>
                  <div class="type-car">{{ vehicle.className }} Class</div>
                  <div
                    class="type-car hidden"
                    :class="{
                      'self-drive': isSelfDrive,
                      'with-driver': !isSelfDrive,
                    }"
                  ></div>
                  <div
                    class="row"
                    v-if="
                      hasPaxCapacity ||
                      hasLargeBaggageCapacity ||
                      hasSmallBaggageCapacity
                    "
                  >
                    <div class="col-sm-12">
                      <div class="capacity-seat" v-if="hasPaxCapacity">
                        Max. Passenger {{ vehicle.feature.paxCapacity }}
                      </div>
                      <div
                        class="capacity-large-baggage"
                        v-if="hasLargeBaggageCapacity"
                      >
                        Big Bag. x{{ vehicle.feature.largeBaggageCapacity }}
                      </div>
                      <div
                        class="capacity-baggage"
                        v-if="hasSmallBaggageCapacity"
                      >
                        Small Bag. x{{ vehicle.feature.smallBaggageCapacity }}
                      </div>
                      <!-- <div
                        :class="{
                          'transmission-automatic': vehicle.transmission === 'Automatic',
                          'transmission-manual': vehicle.transmission === 'Manual',
                        }"
                      >
                        {{
                          vehicle.transmission === "Automatic"
                            ? "Automatic Transmission"
                            : "Manual Gearbox"
                        }}
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.row.text-center -->

              <div
                class="provider-box cRowen-col"
                v-if="searchParameter.mode === 'OnDemand'"
              >
                <div class="provider-name">{{ vehicle.providers[0].name }}</div>
                <!-- <button
                  class="btn btn-info"
                  data-toggle="modal"
                  data-target="#terms-modal"
                >
                  Rental Terms
                </button> -->
              </div>

              <div class="reservation-button">
                <button class="btn btn-block btn-nobg" @click="refresh()">
                  Change Car
                </button>
              </div>
            </div>
          </div>
          <!-- End: Right Panel -->
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import {
  required,
  minValue,
  maxValue,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import _ from "lodash";
import inquiryAvailabilityService from "@/services/shop/availability/inquiryAvailabilityService.js";
import inquiryReservationService from "@/services/shop/reservation/inquiryReservationService.js";
import countryPhoneService from "@/services/master/countryPhoneService.js";
import PdfViewer from "@/components/shared/PdfViewer";
import { convertFromMarketFx } from "@/helpers/numberHelper.js";
import { RideTypeTypes } from "@/models/constants.js";

export default {
  components: { PdfViewer },
  data() {
    return {
      conversionRate: null,
      reservationRequest: {
        correlationId: null,
        serviceType: null,
        vehicleId: null,
        providerId: null,
        departureAirline: null,
        departureFlightNumber: null,
        numberOfPax: null,
        numberOfBigLuggages: null,
        numberOfSmallLuggages: null,
        notes: null,
        booker: {
          companyId: null,
          customerId: null,
          employeeId: null,
          costCenter: null,
          freetext: {
            title: "Mr",
            otherTitle: null,
            fullName: null,
            email: null,
            phoneCode: null,
            phoneNumber: null,
          },
        },
        passengers: [
          {
            companyId: null,
            customerId: null,
            title: "Mr",
            otherTitle: null,
            fullName: null,
            email: null,
            phoneCode: null,
            phoneNumber: null,
            employeeId: null,
            costCenter: null,
          },
        ],
        ancillaries: [],
        passengerNameRecord: null,
        project: null,
        additionalRequest: null,
        adminNotes: null,
        signage: {
          url: null,
          text: null,
          additionalText: null,
        },
        rideType: null,
        selectedProvider: null,
      },
      isSubmitted: false,
      isSelfDrive: false,
      isPassengerSameAsBooker: false,
      moneyFormat: null,
      vehicle: null,
      totalAncillary: 0,
      ancillaries: [],
      rentDays: null,
      items: [],
      airlines: [],
      selectedAncillaries: [],
      companies: [],
      customersAsBooker: [],
      customersAsPassenger: [],
      phoneCodes: [],
      isLoading: false,
      isLoadingForm: true,
      searchParameter: {
        mode: "",
        pickUpLocation: {
          isAirportZone: false,
        },
      },
      personTitles: [
        { value: "Mr", text: "Mr" },
        { value: "Mrs", text: "Mrs" },
        { value: "Ms", text: "Ms" },
        { value: "Other", text: "Others" },
      ],
      rideTypeTypes: null,
      msg: "Please wait",
      userProfile: {},
      useCompanySelection: true,
      useCustomerSelection: true,
      isAirportZone: false,
      isAirportZoneDropOff: false,
      allServices: null,
      signageImageName: null,
      rateTagging: [],
      providers: [],
    };
  },
  validations() {
    const v = {
      reservationRequest: {
        booker: {
          companyId: { required },
          customerId: { required },
        },
        passengers: {
          $each: {
            companyId: { required },
            customerId: { required },
          },
        },
        departureAirline: this.validationDepartureAirline,
        departureFlightNumber: this.validationDepartureFlightNumber,
        notes: { maxLength: maxLength(500) },
        adminNotes: { maxLength: maxLength(500) },
        project: { maxLength: maxLength(300) },
        passengerNameRecord: { maxLength: maxLength(100) },
        additionalRequest: { maxLength: maxLength(500) },
        numberOfPax: {
          maxValue: maxValue(this.vehicle.feature.paxCapacity),
          minValue: minValue(1),
        },
        numberOfBigLuggages: {
          // maxValue: maxValue(this.vehicle.feature.largeBaggageCapacity),
          minValue: minValue(1),
        },
        numberOfSmallLuggages: {
          // maxValue: maxValue(this.vehicle.feature.smallBaggageCapacity),
          minValue: minValue(1),
        },
        selectedProvider: {},
      },
    };

    if (this.isUseFreetext(this.reservationRequest.booker.customerId)) {
      v.reservationRequest.booker.freetext = {
        title: { required },
        otherTitle: {},
        fullName: { required, maxLength: maxLength(150) },
        email: { required, email },
        phoneCode: { required },
        phoneNumber: { required, maxLength: maxLength(20) },
      };
    }

    if (this.isUseFreetext(this.reservationRequest.passengers[0].customerId)) {
      v.reservationRequest.passengers.$each = {
        companyId: { required },
        customerId: { required },
        title: { required },
        otherTitle: {},
        fullName: { required, maxLength: maxLength(150) },
        email: { required, email },
        phoneCode: { required },
        phoneNumber: { required, maxLength: maxLength(20) },
      };
    }

    return v;
  },
  computed: {
    isPDFFile() {
      return (
        this.reservationRequest.signage.url &&
        this.reservationRequest.signage.url.toLowerCase().endsWith(".pdf")
      );
    },
    hasConversionRate() {
      return this.conversionRate && this.conversionRate !== null;
    },
    additionalRequestLength: function () {
      if (this.reservationRequest.additionalRequest) {
        return this.reservationRequest.additionalRequest.length;
      }
      return 0;
    },
    adminNotesLength: function () {
      if (this.reservationRequest.adminNotes) {
        return this.reservationRequest.adminNotes.length;
      }
      return 0;
    },
    driverNotesLength: function () {
      if (this.reservationRequest.notes) {
        return this.reservationRequest.notes.length;
      }
      return 0;
    },
    isServicesExist: function () {
      return this.allServices && this.allServices !== null;
    },
    isAllowAdminNotes: function () {
      return (
        this.isServicesExist &&
        this.allServices["InquiryReservation"].includes("AddEditAdminNote")
      );
    },
    searchParameterPickUpLocation: function () {
      return this.searchParameter.pickUpLocation !== undefined
        ? this.searchParameter.pickUpLocation.name
        : "";
    },
    searchParameterPickUpLocationAddress: function () {
      return this.searchParameter.pickUpLocation !== undefined
        ? this.searchParameter.pickUpLocation.address
        : "";
    },
    searchParameterDropOffLocation: function () {
      return this.searchParameter.dropOffLocation !== undefined &&
        this.searchParameter.dropOffLocation !== null
        ? this.searchParameter.dropOffLocation.name
        : "Same Location";
    },
    searchParameterDropOffLocationAddress: function () {
      return this.searchParameter.dropOffLocation !== undefined &&
        this.searchParameter.dropOffLocation !== null
        ? this.searchParameter.dropOffLocation.address
        : "Same Location";
    },
    pickUpOtherLocationName: function () {
      return this.pickUpOtherLocation !== null
        ? this.pickUpOtherLocation.name
        : "";
    },
    dropOffOtherLocationName: function () {
      return this.dropOffOtherLocation !== null
        ? this.dropOffOtherLocation.name
        : "";
    },
    pickUpOtherLocationRate: function () {
      return this.pickUpOtherLocation !== null
        ? this.pickUpOtherLocation.rate
        : "Select Location by Map";
    },
    dropOffOtherLocationRate: function () {
      return this.dropOffOtherLocation !== null
        ? this.dropOffOtherLocation.rate
        : "Select Location by Map";
    },
    shortPickUpDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDate,
        "D MMM YYYY"
      );
    },
    shortPickUpTime: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDate,
        "HH:mm"
      );
    },
    shortDropOffDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.dropOffDate,
        "D MMM YYYY"
      );
    },
    shortDropOffTime: function () {
      return this.$helper.toDateString(
        this.searchParameter.dropOffDate,
        "HH:mm"
      );
    },
    isAirportTransfer: function () {
      return (
        this.searchParameter &&
        this.searchParameter.serviceType &&
        this.searchParameter.serviceType === "AirportTransfer"
      );
    },
    hasAncillary: function () {
      return this.ancillaries && this.ancillaries.length > 0;
    },
    isAncillarySelected: function () {
      return this.hasAncillary && this.selectedAncillaries.length > 0;
    },
    hasSurcharge: function () {
      return this.vehicle && this.vehicle.surcharge > 0;
    },
    hasPaxCapacity: function () {
      return (
        this.vehicle.feature &&
        this.vehicle.feature.paxCapacity &&
        parseInt(this.vehicle.feature.paxCapacity) > 0
      );
    },
    hasLargeBaggageCapacity: function () {
      return (
        this.vehicle.feature &&
        this.vehicle.feature.largeBaggageCapacity &&
        parseInt(this.vehicle.feature.largeBaggageCapacity) > 0
      );
    },
    hasSmallBaggageCapacity: function () {
      return (
        this.vehicle.feature &&
        this.vehicle.feature.smallBaggageCapacity &&
        parseInt(this.vehicle.feature.smallBaggageCapacity) > 0
      );
    },
    hasVehicleName: function () {
      return (
        (this.vehicle.factoryName && this.factoryName !== "") ||
        (this.vehicle.brandName && this.vehicle.brandName !== "")
      );
    },
    totalInsurance: function () {
      let total = 0;
      if (
        this.isSelfDrive &&
        this.vehicle.selfDriveRate &&
        this.vehicle.selfDriveRate.items
      ) {
        total = this.vehicle.selfDriveRate.items.reduce((a, b) => {
          return a + b.rate;
        }, 0);
      }
      return total;
    },
    grandTotal: function () {
      let total = 0;
      if (this.vehicle) {
        total +=
          this.vehicle.baseFare + this.vehicle.surcharge + this.totalAncillary;
      }
      total += this.totalInsurance;
      return total;
    },
    orderedAirlines: function () {
      const airlines = _.orderBy(this.airlines, "iataCode");
      for (let index = 0; index < airlines.length; index++) {
        const airline = airlines[index];
        airline.label = `(${airline.iataCode}) ${airline.name}`;
      }
      return airlines;
    },
    validationDepartureAirline: function () {
      return this.isAirportTransfer && this.isAirportZone ? { required } : {};
    },
    validationDepartureFlightNumber: function () {
      return this.isAirportTransfer && this.isAirportZone
        ? { required, maxLength: maxLength(6) }
        : {};
    },
    sanitizePhoneNumberBooker: {
      get() {
        return this.reservationRequest.booker.freetext.phoneNumber;
      },
      set(value) {
        this.reservationRequest.booker.freetext.phoneNumber = value.replace(
          /\D/g,
          ""
        );
      },
    },
    sanitizePhoneNumberPax: {
      get() {
        return this.reservationRequest.passengers[0].phoneNumber;
      },
      set(value) {
        this.reservationRequest.passengers[0].phoneNumber = value.replace(
          /\D/g,
          ""
        );
      },
    },
  },
  async created() {
    this.$helper.scrollTop();
    await this.getBookingInfo();
    await this.getPhoneCodes();

    this.$store.dispatch("user/getProfile").then((profile) => {
      this.allServices = profile.services;
      this.userProfile = profile;
      this.setupForm();
    });
    this.rideTypeTypes = RideTypeTypes;
    this.isLoadingForm = false;
  },
  updated() {
    this.$helper.alphabetsOnly();
    this.$helper.alphabetsCharactersOnly();
    this.$helper.numbersOnly();
    this.$helper.alphabetsNumbersOnly();

    // setTimeout(() => {
    //   $("#RefreshConfirmation").modal({ backdrop: "static", keyboard: false });
    // }, this.$helper.fromMinutestoMilliseconds(30));
  },
  methods: {
    checkSameCurrencyCode(currencyCode) {
      const conversionRateCurrency =
        this.conversionRate && this.conversionRate.currency;
      return _.isEqual(conversionRateCurrency, currencyCode);
    },
    getLocalCurrency(originalCurrency) {
      return convertFromMarketFx(
        originalCurrency,
        this.conversionRate.conversionRate,
        this.conversionRate.conversionFormula
      );
    },
    setupForm() {
      if (
        this.userProfile.selectors &&
        this.userProfile.selectors["Companies"]
      ) {
        const userCompany = this.companies.find(
          (company) =>
            company.id == this.userProfile.selectors["Companies"].defaultId
        );

        if (userCompany) {
          this.reservationRequest.booker.companyId = userCompany.id;
          this.getBookersByCompanyId(userCompany.id);

          const userCustomer = userCompany.customers.find(
            (cust) => cust.id == this.userProfile.id
          );

          if (userCustomer) {
            this.reservationRequest.booker.customerId = userCustomer.id;
          }
        }
      } else {
        this.useCompanySelection = false;
        this.useCustomerSelection = false;
        this.reservationRequest.booker.companyId = this.$helper.emptyGuid();
        this.reservationRequest.booker.customerId = this.$helper.emptyGuid();
        this.reservationRequest.passengers[0].companyId =
          this.$helper.emptyGuid();
        this.reservationRequest.passengers[0].customerId =
          this.$helper.emptyGuid();

        if (this.companies.length) {
          this.getBookersByCompanyId(this.companies[0].id);
          this.getPassengersByCompanyId(this.companies[0].id);
          this.reservationRequest.booker.companyId = this.companies[0].id;
          this.reservationRequest.passengers[0].companyId =
            this.companies[0].id;
          this.useCompanySelection = true;
          this.useCustomerSelection = true;
        }
      }
    },
    onChangeAncillary(ancillary) {
      this.totalAncillary = 0;
      this.selectedAncillaries = this.ancillaries.filter(
        (x) => x.quantity && parseInt(x.quantity) > 0
      );
      for (let i = 0; i < this.selectedAncillaries.length; i++) {
        const item = this.selectedAncillaries[i];
        item.subtotal = item.rate * parseInt(item.quantity);
        this.totalAncillary += item.subtotal;
      }
    },
    onBlurAncillary(item) {
      if (item.quantity === "") {
        item.quantity = 0;
      }
    },
    isUseFreetext(customerId) {
      return customerId === this.$helper.emptyGuid();
    },
    getBookersByCompanyId(companyId) {
      const freetextValue = {
        companyId: companyId,
        emails: [],
        fullName: "Free Text",
        label: "Free Text",
        gender: null,
        id: this.$helper.emptyGuid(),
        phones: [],
        title: null,
        employeeId: null,
        costCenter: null,
      };

      this.customersAsBooker = this.companies
        .flatMap((x) => x.customers)
        .filter((x) => x.companyId === companyId);

      this.customersAsBooker = this.$helper.prependToArray(
        freetextValue,
        this.customersAsBooker
      );

      this.reservationRequest.booker.customerId = null;
      this.reservationRequest.passengers[0].customerId = null;
      if (this.isPassengerSameAsBooker) {
        this.reservationRequest.passengers[0].companyId = companyId;
      } else {
        this.customersAsPassenger = [];
        this.reservationRequest.passengers[0].companyId = null;
      }
    },
    getPassengersByCompanyId(companyId) {
      const freetextValue = {
        companyId: companyId,
        emails: [],
        fullName: "Free Text",
        label: "Free Text",
        gender: null,
        id: this.$helper.emptyGuid(),
        phones: [],
        title: null,
        employeeId: null,
        costCenter: null,
      };

      this.customersAsPassenger = this.companies
        .flatMap((x) => x.customers)
        .filter((x) => x.companyId === companyId);

      this.customersAsPassenger = this.$helper.prependToArray(
        freetextValue,
        this.customersAsPassenger
      );

      this.reservationRequest.passengers[0].customerId = null;
    },
    onChangeBooker(item) {
      if (this.isPassengerSameAsBooker) {
        this.customersAsPassenger = this.customersAsBooker;
        this.reservationRequest.passengers[0].customerId = item;
      } else {
        this.reservationRequest.passengers[0].companyId = null;
        this.reservationRequest.passengers[0].customerId = null;
      }
    },
    refresh() {
      const queryParam = {};
      switch (this.searchParameter.serviceType.toLocaleLowerCase()) {
        case "airporttransfer":
          // pick-up
          queryParam.plt = this.searchParameter.pickUpLocation.latitude;
          queryParam.plg = this.searchParameter.pickUpLocation.longitude;
          queryParam.pcd = this.searchParameter.pickUpLocation.code;
          queryParam.pad = this.searchParameter.pickUpLocation.address;
          queryParam.pnm = this.searchParameter.pickUpLocation.name;
          queryParam.pcn = this.searchParameter.pickUpLocation.country;
          queryParam.pia = this.searchParameter.pickUpLocation.isAirportZone;

          // drop-off
          queryParam.dlt = this.searchParameter.dropOffLocation.latitude;
          queryParam.dlg = this.searchParameter.dropOffLocation.longitude;
          queryParam.dcd = this.searchParameter.dropOffLocation.code;
          queryParam.dad = this.searchParameter.dropOffLocation.address;
          queryParam.dnm = this.searchParameter.dropOffLocation.name;
          queryParam.dcn = this.searchParameter.dropOffLocation.country;
          queryParam.dia = this.searchParameter.dropOffLocation.isAirportZone;

          // start rent
          queryParam.ptm =
            this.searchParameter.pickUpDate.year +
            "." +
            this.searchParameter.pickUpDate.month +
            "." +
            this.searchParameter.pickUpDate.day +
            "-" +
            this.searchParameter.pickUpDate.hour +
            "." +
            this.searchParameter.pickUpDate.minute;

          // service type
          queryParam.svc = "airporttransfer";
          break;
        case "rental":
          // pick-up location (coordinate & address)
          queryParam.plt = this.searchParameter.pickUpLocation.latitude;
          queryParam.plg = this.searchParameter.pickUpLocation.longitude;
          queryParam.pad = this.searchParameter.pickUpLocation.address;
          queryParam.pnm = this.searchParameter.pickUpLocation.name;
          queryParam.pcn = this.searchParameter.pickUpLocation.country;

          // start rent
          queryParam.str =
            this.searchParameter.pickUpDate.year +
            "." +
            this.searchParameter.pickUpDate.month +
            "." +
            this.searchParameter.pickUpDate.day +
            "-" +
            this.searchParameter.pickUpDate.hour +
            "." +
            this.searchParameter.pickUpDate.minute;

          // end rent
          queryParam.enr =
            this.searchParameter.dropOffDate.year +
            "." +
            this.searchParameter.dropOffDate.month +
            "." +
            this.searchParameter.dropOffDate.day +
            "-" +
            this.searchParameter.dropOffDate.hour +
            "." +
            this.searchParameter.dropOffDate.minute;

          // with driver / self drive
          queryParam.slf = this.isSelfDrive;

          // service type
          queryParam.svc = "rental";
          break;
      }
      queryParam.company = this.companies.length ? this.companies[0].id : null;
      queryParam.mode = this.searchParameter.mode;
      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);
      this.$router.push({ path: "/availability/inquiry", query: queryParam });
    },
    copyBooker() {
      if (this.isPassengerSameAsBooker) {
        if (
          this.reservationRequest.booker.companyId !=
          this.reservationRequest.passengers[0].companyId
        ) {
          this.getPassengersByCompanyId(
            this.reservationRequest.booker.companyId
          );
        }
        this.$nextTick(() => {
          this.reservationRequest.passengers[0].companyId =
            this.reservationRequest.booker.companyId;
          this.reservationRequest.passengers[0].customerId =
            this.reservationRequest.booker.customerId;
          this.reservationRequest.passengers[0].title =
            this.reservationRequest.booker.freetext.title;
          this.reservationRequest.passengers[0].otherTitle =
            this.reservationRequest.booker.freetext.otherTitle;
          this.reservationRequest.passengers[0].fullName =
            this.reservationRequest.booker.freetext.fullName;
          this.reservationRequest.passengers[0].phoneCode =
            this.reservationRequest.booker.freetext.phoneCode;
          this.reservationRequest.passengers[0].phoneNumber =
            this.reservationRequest.booker.freetext.phoneNumber;
          this.reservationRequest.passengers[0].email =
            this.reservationRequest.booker.freetext.email;
        });
      } else {
        if (this.useCompanySelection && this.useCustomerSelection) {
          this.reservationRequest.passengers[0].companyId = null;
          this.reservationRequest.passengers[0].customerId = null;
        } else {
          this.reservationRequest.passengers[0].companyId =
            this.$helper.emptyGuid();
          this.reservationRequest.passengers[0].customerId =
            this.$helper.emptyGuid();
        }

        this.reservationRequest.passengers[0].title = null;
        this.reservationRequest.passengers[0].otherTitle = null;
        this.reservationRequest.passengers[0].fullName = null;
        this.reservationRequest.passengers[0].phoneCode = null;
        this.reservationRequest.passengers[0].phoneNumber = null;
        this.reservationRequest.passengers[0].email = null;
      }
    },
    constructPayload() {
      const payload = {
        signage: this.reservationRequest.signage.url
          ? this.reservationRequest.signage
          : null,
        serviceType: this.searchParameter.serviceType,
        correlationId: this.$route.params.id,
        selectorId: this.reservationRequest.selectorId,
        departureAirline:
          (this.isAirportTransfer && this.isAirportZone) ||
          (this.isAirportZoneDropOff &&
            Boolean(this.reservationRequest.departureAirline))
            ? this.reservationRequest.departureAirline.toUpperCase()
            : null,
        departureFlightNumber: this.reservationRequest.departureFlightNumber,
        notes: this.reservationRequest.notes
          ? this.reservationRequest.notes
          : null,
        booker: {
          companyId: this.reservationRequest.booker.companyId,
          customerId: this.reservationRequest.booker.customerId,
          employeeId: this.reservationRequest.booker.employeeId,
          costCenter: this.reservationRequest.booker.costCenter,
        },
        passengers: [
          {
            companyId: this.reservationRequest.passengers[0].companyId,
            customerId: this.reservationRequest.passengers[0].customerId,
            employeeId: this.reservationRequest.passengers[0].employeeId,
            costCenter: this.reservationRequest.passengers[0].costCenter,
          },
        ],
        numberOfPassengers: this.reservationRequest.numberOfPax
          ? this.reservationRequest.numberOfPax
          : null,
        numberOfBigLuggages: this.reservationRequest.numberOfBigLuggages
          ? this.reservationRequest.numberOfBigLuggages
          : null,
        numberOfSmallLuggages: this.reservationRequest.numberOfSmallLuggages
          ? this.reservationRequest.numberOfSmallLuggages
          : null,
        passengerNameRecord: this.reservationRequest.passengerNameRecord
          ? this.reservationRequest.passengerNameRecord
          : null,
        project: this.reservationRequest.project
          ? this.reservationRequest.project
          : null,
        additionalRequest: this.reservationRequest.additionalRequest
          ? this.reservationRequest.additionalRequest
          : null,
        adminNotes: this.reservationRequest.adminNotes
          ? this.reservationRequest.adminNotes
          : null,
        invoiceNumber: this.reservationRequest.invoiceNumber
          ? this.reservationRequest.invoiceNumber
          : null,
        ancillaries: [],
        rideType: this.reservationRequest.rideType
          ? this.reservationRequest.rideType
          : null,
        selectedProvider: this.reservationRequest.selectedProvider
          ? this.reservationRequest.selectedProvider
          : null,
      };

      if (this.isUseFreetext(payload.booker.customerId)) {
        payload.booker.freetext = {
          ...this.reservationRequest.booker.freetext,
          title:
            this.reservationRequest.booker.freetext.title === "Other"
              ? this.reservationRequest.booker.freetext.otherTitle
              : this.reservationRequest.booker.freetext.title,
        };
      }

      if (this.isUseFreetext(payload.passengers[0].customerId)) {
        payload.passengers[0].freetext = {
          title:
            this.reservationRequest.passengers[0].title === "Other"
              ? this.reservationRequest.passengers[0].otherTitle
              : this.reservationRequest.passengers[0].title,
          fullName: this.reservationRequest.passengers[0].fullName,
          email: this.reservationRequest.passengers[0].email,
          phoneCode: this.reservationRequest.passengers[0].phoneCode,
          phoneNumber: this.reservationRequest.passengers[0].phoneNumber,
        };
      }

      const overrideBookerWithFreetext =
        payload.booker.companyId === this.$helper.emptyGuid() &&
        payload.booker.customerId === this.$helper.emptyGuid();
      const overridePaxWithFreetext =
        payload.passengers[0].companyId === this.$helper.emptyGuid() &&
        payload.passengers[0].customerId === this.$helper.emptyGuid();

      if (overrideBookerWithFreetext) {
        payload.booker = {
          employeeId: this.reservationRequest.booker.employeeId,
          costCenter: this.reservationRequest.booker.costCenter,
          freetext: {
            ...this.reservationRequest.booker.freetext,
            title:
              this.reservationRequest.booker.freetext.title === "Other"
                ? this.reservationRequest.booker.freetext.otherTitle
                : this.reservationRequest.booker.freetext.title,
          },
        };
      }

      if (overridePaxWithFreetext) {
        payload.passengers[0] = {
          employeeId: this.reservationRequest.passengers[0].employeeId,
          costCenter: this.reservationRequest.passengers[0].costCenter,
          freetext: {
            title:
              this.reservationRequest.passengers[0].title === "Other"
                ? this.reservationRequest.passengers[0].otherTitle
                : this.reservationRequest.passengers[0].title,
            fullName: this.reservationRequest.passengers[0].fullName,
            email: this.reservationRequest.passengers[0].email,
            phoneCode: this.reservationRequest.passengers[0].phoneCode,
            phoneNumber: this.reservationRequest.passengers[0].phoneNumber,
          },
        };
      }

      if (this.selectedAncillaries && this.selectedAncillaries.length > 0) {
        payload.ancillaries = this.selectedAncillaries.map((ancillary) => {
          return {
            id: ancillary.id,
            quantity: parseInt(ancillary.quantity),
          };
        });
      }

      return payload;
    },
    async getPhoneCodes() {
      this.phoneCodes = await countryPhoneService.getAll();
      for (let i = 0; i < this.phoneCodes.length; i++) {
        const item = this.phoneCodes[i];
        item.label = `${item.iata} (+${item.dial})`;
        item.icon = `iti-flag ${item.iata.toLowerCase()}`;
      }
    },
    async getBookingInfo() {
      try {
        this.isLoading = true;

        const response = await inquiryAvailabilityService.loadBookingForm({
          correlationId: this.$route.params.id,
        });
        this.conversionRate = response.conversionRate;
        this.reservationRequest.correlationId = this.$route.params.id;
        this.reservationRequest.serviceType = response.queryCache.serviceType;
        this.reservationRequest.selectorId =
          response.queryCache.data.selectorId;
        this.reservationRequest.selfDriveRateType =
          response.queryCache.selfDriveRateType;
        this.moneyFormat = response.queryCache.moneyFormat;
        this.searchParameter = {
          dropOffDate: response.queryCache.dropOffDate,
          dropOffLocation: response.queryCache.dropOffLocation,
          serviceType: response.queryCache.serviceType,
          pickUpDate: response.queryCache.pickUpDate,
          pickUpLocation: response.queryCache.pickUpLocation,
          mode: response.queryCache.mode,
        };
        this.isSelfDrive = response.queryCache.isSelfDrive;
        this.rentDays = response.queryCache.rentDays;
        this.vehicle = response.queryCache.data;
        this.rateTagging = response.queryCache.data.rateTaggings;
        this.ancillaries = response.queryCache.data.ancillaries;
        this.airlines = response.airlines;
        this.companies = response.companies;
        this.isAirportZone = response.queryCache.pickUpLocation.isAirportZone;
        this.isAirportZoneDropOff =
          response.queryCache.dropOffLocation.isAirportZone;
        this.providers = response.queryCache.data.providers;

        if (this.ancillaries && this.ancillaries.length > 0) {
          for (let i = 0; i < this.ancillaries.length; i++) {
            const ancillary = this.ancillaries[i];
            this.reservationRequest.ancillaries.push({ quantity: 0 });
          }
        }

        for (let i = 0; i < this.companies.length; i++) {
          const company = this.companies[i];
          for (let j = 0; j < company.customers.length; j++) {
            const customer = company.customers[j];
            customer.label = `${customer.title}. ${customer.fullName}`;
          }
        }

        if (localStorage.getItem("reservationRequest") !== null) {
          this.reservationRequest = JSON.parse(
            localStorage.getItem("reservationRequest")
          );
        }
      } catch (error) {
        this.$helper.redirectToServerError(this);
        return;
      } finally {
        this.isLoading = false;
      }
    },
    async uploadSignage(event) {
      this.isLoading = true;
      const maxAllowedSize = 1 * 1024 * 1024;
      if (event.target.files[0].size > maxAllowedSize) {
        this.$notification.error("File signage must be less than 1MB", {
          title: "Error",
        });
        this.isLoading = false;
        return;
      }
      try {
        let formData = new FormData();
        formData.append("file", event.target.files[0]);
        const response = await inquiryReservationService.uploadSignage(
          formData
        );

        this.reservationRequest.signage.url = response;
        this.signageImageName = event.target.files[0].name;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    clearPreviewSignage() {
      this.reservationRequest.signage.url = null;
      this.signageImageName = null;
    },
    async validateDoubleBook() {
      this.isSubmitted = true;

      this.reservationRequest.booker.freetext.email = this.reservationRequest
        .booker.freetext.email
        ? this.reservationRequest.booker.freetext.email.toLowerCase()
        : null;
      this.reservationRequest.passengers[0].email = this.reservationRequest
        .passengers[0].email
        ? this.reservationRequest.passengers[0].email.toLowerCase()
        : null;

      this.$v.reservationRequest.$touch();
      if (this.$v.reservationRequest.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }
      try {
        this.isLoading = true;
        await this.bookNow();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async bookNow() {
      try {
        this.isLoading = true;

        const payload = this.constructPayload();

        const reservationNumber = await inquiryReservationService.create(
          payload
        );

        // book success, then redirects to reservation page
        this.$router.push({
          path: `/reservation/inquiry/${reservationNumber}`,
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    reservationRequest: {
      deep: true,
      handler: function (value) {
        localStorage.setItem("reservationRequest", JSON.stringify(value));
      },
    },
  },
  beforeDestroy() {
    localStorage.removeItem("reservationRequest");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reservation/inquiry/ReservationForm.vue